import { computed, ref } from 'vue';

export function useAsync<T, K extends any[]>(cb: (...args: K) => Promise<T>) {
    const state = ref<'pending' | 'working' | 'success' | 'error'>('pending');
    const result = ref<T>();
    const errors = ref<string[]>([]);

    const fn = async (...args: K) => {
        try {
            state.value = 'working';
            errors.value = [];
            const data = await cb(...args);
            result.value = data;
            state.value = 'success';
        } catch (e) {
            if ((e as any).response?.status == 422) {
                const { data } = (e as any).response;
                if (data.errors && Array.isArray(data.errors)) {
                    for (const err of data.errors) {
                        errors.value.push(err.message);
                    }
                } else {
                    for (const k in data) {
                        errors.value.push(Array.isArray(data[k]) ? data[k][0] : data[k]);
                    }
                }
            } else {
                // const err = e.response?.data?.error || e.toString();
                // toast.error(err);
            }
            state.value = 'error';
        } finally {
        }
    };

    return {
        state,
        result,
        errors,
        fn,
        isWorking: computed(() => state.value == 'working'),
        isSuccess: computed(() => state.value == 'success'),
        isError: computed(() => state.value == 'error'),
    };
}
